/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargerVolumeFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ChargerVolume, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/makes/volume
 */
export interface VolumeRequestBuilder extends BaseRequestBuilder<VolumeRequestBuilder> {
    /**
     * GetChargerVolume
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargerVolume>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ChargerVolume | undefined>;
    /**
     * GetChargerVolume
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const VolumeRequestBuilderUriTemplate = "{+baseurl}/chargepoints/makes/volume";
/**
 * Metadata for all the requests in the request builder.
 */
export const VolumeRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: VolumeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createChargerVolumeFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
